import { BadgeVariant } from '@components/Badge/types'
import { DateTime } from 'luxon'

export const getDurationStatus = (
    startDate: string | DateTime,
    endDate: string | DateTime
): {
    tKey: string
    variant: BadgeVariant
} => {
    const start = startDate instanceof DateTime ? startDate.toJSDate() : new Date(startDate)
    const end = endDate instanceof DateTime ? endDate.toJSDate() : new Date(endDate)
    const now = new Date()
    const parsedStartDate = new Date(start)
    const parsedEndDate = new Date(end)

    // active
    if (now >= parsedStartDate && now <= parsedEndDate)
        return {
            tKey: 'checkout.success.active',
            variant: 'positive'
        }
    // pending
    if (now < parsedStartDate)
        return {
            tKey: 'checkout.success.upcoming',
            variant: 'information'
        }
    // expired
    if (now > parsedEndDate)
        return {
            tKey: 'checkout.success.past',
            variant: 'default'
        }

    return {
        tKey: 'checkout.success.error',
        variant: 'default'
    }
}

export const getSubscriptionDurationStatus = (
    startDate: string,
    endDate: string | null
): {
    tKey: string
    variant: BadgeVariant
} => {
    if (endDate !== null)
        return {
            tKey: 'checkout.success.past',
            variant: 'default'
        }
    const start = new Date(startDate)
    const now = new Date()

    // active
    if (now >= start)
        return {
            tKey: 'checkout.success.active',
            variant: 'positive'
        }
    // pending
    if (now < start)
        return {
            tKey: 'checkout.success.upcoming',
            variant: 'information'
        }

    return {
        tKey: 'checkout.success.error',
        variant: 'default'
    }
}
